import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter, Link } from 'react-router-dom';

import PropTypes from 'prop-types';
import MetaTags from 'react-meta-tags';
import SweetAlert from 'react-bootstrap-sweetalert';

import 'react-bootstrap-table2-filter/dist/react-bootstrap-table2-filter.min.css';
import BootstrapTable from 'react-bootstrap-table-next';
import filterFactory from 'react-bootstrap-table2-filter';

import InputMask from 'react-input-mask';
import { AvForm, AvField } from 'availity-reactstrap-validation';
import BtnLoader from '../../components/Loaders/btnLoader';
import {
  Card,
  CardBody,
  Col,
  Container,
  Row,
  Modal,
  Button,
  ModalHeader,
  ModalBody,
  FormGroup,
  Label,
  Alert,
  Input
} from 'reactstrap';
import paginationFactory, { PaginationProvider, PaginationListStandalone, SizePerPageDropdownStandalone } from 'react-bootstrap-table2-paginator';
import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit';

import { getProducts, addProduct, updateProduct, deleteProduct, getArrivedProducts } from '../../store/purchases/actions';

import PageLoader from '../../components/Loaders/pageLoader';
//Import Breadcrumb
import Breadcrumbs from '../../components/Breadcrumb';
import { Notification } from '../../components/Notifications/notifications';

class ProductOrderList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      productToOrder: [],
      productsArr: [],
      my_requested_orders: [],
      selectedRows: [],
      requestedDate: new Date().toLocaleDateString('en-GB'),
      modalNewProductToOrder: false,
      checkCno: false,
      isEdit: false,
      viewArrived: false,
      correctDate: true,
      correctDateEad: true,
      myOrdersToggle: true,
      ProductsListColumns: [
        {
          text: 'ID',
          dataField: '_id',
          sort: true,
          editable: false,
          formatter: (cell, row, rowIndex) => rowIndex + 1
        },
        {
          text: 'Request Date',
          dataField: 'updatedAt',
          sort: true,
          editable: false,
          formatter: (cellContent, requestedProduct) => (
            <h5 className='font-size-16 mb-1'>
              {requestedProduct != null &&
                new Date(requestedProduct.updatedAt).toLocaleDateString('en-GB')}
            </h5>
          )
        },
        {
          text: '1с №',
          dataField: 'cNo',
          sort: true,
          hidden: false,
          formatter: (cellContent, requestedProduct) => (
            <div>
              <h5 className='font-size-16 mb-1'>#{requestedProduct.cNo}</h5>
            </div>
          )
        },
        {
          text: 'Client Name',
          dataField: 'client_info',
          sort: true,
          editable: false,
          formatter: (cellContent, requestedProduct) => (
            <h5 className='font-size-16 name-width mb-1'>
              {requestedProduct.client_info && requestedProduct.client_info.clientName.replace(/%20/g, " ")}
            </h5>
          )
        },
        {
          text: 'Manager',
          dataField: 'manager',
          sort: true,
          editable: false,
          formatter: (cellContent, requestedProduct) => (
            <div className='slname-width'>
              <h5 className='font-size-16 mb-1'>
                {requestedProduct.manager ? (
                <span>
                  <div>
                    {!requestedProduct.manager.profilePic ? (
                    <div className='avatar-sm m-2 d-inline-block'>
                      <span className='avatar-title rounded-circle'>
                        {requestedProduct.manager.fname.charAt(0)}
                      </span>
                    </div>
                    ) : (<img className='rounded-circle avatar-sm m-2' src={requestedProduct.manager.profilePic} alt='profile pic'/>)}
                    <span>
                      {requestedProduct.manager.fname} {requestedProduct.manager.sname}
                    </span>
                  </div>
                </span>
                ) : null}
              </h5>
              {/* <h5 className='font-size-16 mb-1'>
                {requestedProduct.manager && requestedProduct.manager.fname +' '+requestedProduct.manager.sname}
              </h5> */}
            </div>
          )
        },
        {
          text: 'Product',
          dataField: 'product',
          sort: true,
          hidden: false,
          editable: false,
          formatter: (cellContent, requestedProduct) => (
            <>
            {requestedProduct.products.map((prod, index) => {
              const isCompleted = requestedProduct.setAsOrdered[index] === true;
              return (
                <h5 className={`font-size-16 mb-1 ${isCompleted ? 'completed-row' : ''}`} key={index}>
                  {prod} <b>{requestedProduct.comments.length > index && requestedProduct.comments[index].split('<br/>').map((line, i) => (
                      <React.Fragment key={i}>
                        {line}
                        <br />
                      </React.Fragment>
                    ))}</b>
                  <br />

                </h5>
              );
            })}
            </>
          )
        },
        {
          text: 'Quantity',
          dataField: 'qty',
          sort: true,
          hidden: false,
          editable: false,
          formatter: (cellContent, requestedProduct) => (
            <>
              {requestedProduct.qtys.map((qt, index) => {
                return (
                  <h5 className='font-size-16 mb-1 text-center' key={index}>
                    {qt}
                    <br />
                    <br />
                  </h5>
                );
              })}
            </>
          )
        },
        {
          dataField: 'menu',
          //   isDummyField: true,
          text: 'Action',
          editable: false,
          formatter: (cellContent, requestedProduct) => (
            <div className='d-flex gap-3'>
              {/* {(requestedProduct.manager == this.state.profile.workEmail ||
                this.state.profile.workEmail == 'tatyana.tsoy@korupharma.com') && ( */}
                <>
                  {requestedProduct.setAsOrdered !== true && (
                    <>
                      <Link className='text-success' to='#'>
                        <i
                          className='mdi mdi-pencil font-size-18'
                          id='edittooltip'
                          onClick={() => this.handleEditOrderClick(requestedProduct)}
                        ></i>
                      </Link>
                      {this.props.profileData.permissions.includes('purchaseListAccess') && (
                        <Link className='text-primary' to='#'>
                          <i
                            className='mdi mdi-marker-check font-size-18'
                            // id='deletetooltip'
                            onClick={() => this.handleOrderedStatus(requestedProduct)}
                          ></i>
                        </Link>
                      )}
                      <Link className='text-danger' to='#'>
                        <i
                          className='mdi mdi-delete font-size-18'
                          id='deletetooltip'
                          onClick={() => this.handleDeleteRequest(requestedProduct)}
                        ></i>
                      </Link>
                    </>
                  )}
                </>
              {/* )} */}
            </div>
          )
        }
      ]
    };
    this.getScreenHeight = this.getScreenHeight.bind(this);
    this.groupedData = this.groupedData.bind(this);
    this.filterMyOrders = this.filterMyOrders.bind(this);
    this.toggleMyOrders = this.toggleMyOrders.bind(this);
    this.rowClasses = this.rowClasses.bind(this);

    this.handleNewOrderClick = this.handleNewOrderClick.bind(this);
    this.handleHideCompletedOrders = this.handleHideCompletedOrders.bind(this);
    this.handleViewCompletedOrders = this.handleViewCompletedOrders.bind(this);
    this.handleEditOrderClick = this.handleEditOrderClick.bind(this);
    this.toggleNewOrderModal = this.toggleNewOrderModal.bind(this);
    this.onChange = this.onChange.bind(this);
    this.checkExistingOrder = this.checkExistingOrder.bind(this);
    this.handleValidRequestSubmit = this.handleValidRequestSubmit.bind(this);

    this.handleOrderedStatus = this.handleOrderedStatus.bind(this);
    this.handleDeleteRequest = this.handleDeleteRequest.bind(this);
    this.indication = this.indication.bind(this);
  }
  componentDidMount() {
    const { onGetProductsToOrder } = this.props
    onGetProductsToOrder()
    window.addEventListener('load', this.getScreenHeight);
    window.addEventListener('click', this.getScreenHeight, { once: true });
    window.addEventListener('resize', this.getScreenHeight);
  }
  componentWillUnmount() {
    window.removeEventListener('load', this.getScreenHeight);
    window.removeEventListener('click', this.getScreenHeight);
    window.removeEventListener('resize', this.getScreenHeight);
  }
  /**
   * Get screen height to set it for table
   */
  getScreenHeight = (click) => {
    if (document.getElementById('card-section') != null) {
      let screenHeight = document.getElementById('card-section').offsetHeight;
      document
        .querySelector('.react-bootstrap-table')
        .setAttribute('style', 'height: calc(' + screenHeight + 'px - 120px); overflow: auto;');
    }
  };
  /**
   * Group received data into required array
   * @returns array
   */
  groupedData = (data) => {
    const groupedData = {};

    data.forEach((obj) => {
      if (!groupedData[obj.cNo]) {
        groupedData[obj.cNo] = {
          date: obj.date,
          updatedAt: obj.updatedAt,
          ead: obj.ead,
          setAsOrdered: [],
          setAsArrived: obj.setAsArrived,
          client_info: obj.client_info,
          _id: obj._id,
          cNo: obj.cNo,
          manager: obj.manager,
          ids: [],
          products: [],
          comments: [],
          qtys: [],
          dates: [],
          categories: [],
          trackers: []
        };
      } else {
        // keep the latest date
        if (new Date(obj.date) > new Date(groupedData[obj.cNo].date)) {
          groupedData[obj.cNo].date = obj.date;
        }
        // keep the latest updatedAt
        if (new Date(obj.updatedAt) > new Date(groupedData[obj.cNo].updatedAt)) {
          groupedData[obj.cNo].updatedAt = obj.updatedAt;
        }
      }

      groupedData[obj.cNo].ids.push(obj._id);
      groupedData[obj.cNo].products.push(obj.product);
      groupedData[obj.cNo].comments.push(obj.comments);
      groupedData[obj.cNo].qtys.push(obj.qty);
      groupedData[obj.cNo].dates.push(obj.ead);
      groupedData[obj.cNo].setAsOrdered.push(obj.setAsOrdered);
      groupedData[obj.cNo].categories.push(obj.category);
      groupedData[obj.cNo].trackers.push(obj.tracker);
    });

    console.log('Grouped Data:');
    return Object.values(groupedData);
  };
  /**
   * Function to display orders only related to login person orders
   * @param {*} e
   */
//   filterMyOrders = (e) => {
//     const { products, profileData } = this.props;
//     const { myOrdersToggle } = this.state;
//     this.toggleMyOrders();
//     let my_requested_orders = [];
//     if (myOrdersToggle === true) {
//       products.map((order) => {
//         if (order.manager._id === profileData._id) {
//           my_requested_orders.push(order);
//         }
//         this.setState({ my_requested_orders: my_requested_orders });
//       });
//     } else {
//       this.setState({ my_requested_orders: [] });
//     }
//   };
  filterMyOrders = (e) => {
    const { products, profileData } = this.props;
    // const { myOrdersToggle } = this.state;
    let my_requested_orders = [];
    let test_arr = [];
    this.toggleMyOrders();
    if (e.target.checked === true) {
      products.map((order) => {
        if (order.manager._id === profileData._id ) {
          my_requested_orders.push(order);
        }
      });
      if (my_requested_orders.length === 0) {
        my_requested_orders.push({ manager: 'No Results Found' });
      }
      test_arr = this.groupedData(my_requested_orders)
      this.setState({ my_requested_orders: test_arr });
      // onGetSpecificBattlefield(values);
    } else {
      this.setState({ my_requested_orders: [] });
    }
    // this.props.onStateChange('filter', my_requested_orders);
  };
  /**
   * Display empty table
   * @returns
   */
  indication = () => {
    let emptyMessage = '';
    if (
      this.state.my_requested_orders.length !== 0 &&
      this.state.my_requested_orders[0]['manager'] === 'No Results Found'
    ) {
      emptyMessage = `No Results Found`;
    } 
    return emptyMessage;
  };
  /**
   * Toggle orders
   */
  toggleMyOrders = () => this.setState((prevState) => ({ myOrdersToggle: !prevState.myOrdersToggle }));
  /**
   * @param {Arr} row
   * @param {Int} rowIndex
   * @returns class to selected rows
   */
  rowClasses = (row, rowIndex) => {
    let classes = null;
    if (Array.isArray(row.setAsOrdered) && row.setAsOrdered.every(val => val === true)) {
      classes = 'completed-row';
    }
    return classes;
  };
  /**
   * Empty product to order array and open new order modal
   */
  handleNewOrderClick = () => {
    this.setState({
      productToOrder: [],
      isEdit: false,
      productsArr: [],
      requestedDate: new Date().toLocaleDateString('en-GB')
    });
    this.toggleNewOrderModal();
  };
  /**
   * Hide arrived orders
   */
  handleHideCompletedOrders = () => {
    const { products, onUpdateProductToOrder } = this.props;
    let updateProductOrder = [];
    products.map((row) => {
      if (row.setAsOrdered) {
        updateProductOrder = {
          _id: row._id,
          cNo: row.cNo,
          setAsArrived: true
        };
        onUpdateProductToOrder(updateProductOrder);
        updateProductOrder = [];
      }
    });
    window.location.reload();
  };
  /**
   * Hide arrived orders
   */
  handleViewCompletedOrders = (e) => {
    const { onGetArrivedProducts } = this.props;
    const { viewArrived } = this.state;
    if (viewArrived) {
      e.preventDefault();
      window.location.reload();
    } else {
      this.setState({ viewArrived: true });
      onGetArrivedProducts('arrived');
    }
    // let updatePurchaseOrder = [];
    // purchases.map((row) => {
    //   if (row.arrived) {
    //     updatePurchaseOrder = {
    //       _id: row._id,
    //       hidden: true
    //     }
    //     onUpdatePurchase(updatePurchaseOrder);
    //     updatePurchaseOrder = []
    //   }
    // });
  };
  /**
   * Assign selected array for editing
   * @param {*} arg 
   */
  handleEditOrderClick = (selectedOrder) => {
    let requestedProducts = [];
    selectedOrder.products.map((v, i) => {
      requestedProducts.push({
        prodName: v,
        prodQty: selectedOrder.qtys[i],
        cNo: selectedOrder.cNo,
        category: selectedOrder.categories[i]
      });
    });
    this.setState({
      productToOrder: {
        ids: selectedOrder.ids,
        manager: selectedOrder.manager,
        // commentaries: selectedOrder.commentaries
      },
      productsArr: requestedProducts,
      requestedDate: new Date(selectedOrder.date).toLocaleDateString('en-GB'),
      isEdit: true,
    });
    this.toggleNewOrderModal();
  };
  /**
   * Toggle Modal window
   * @returns
   */
  toggleNewOrderModal = () => this.setState((prevState) => ({ modalNewProductToOrder: !prevState.modalNewProductToOrder }));
  /**
   * Check date input and display error if it is wrong
   * @param {*} event 
   */
  onChange = (event) => {
    if (parseFloat(event.target.value.substring(3, 5)) > 12) {
      this.setState({ correctDate: false });
    } else {
      this.setState({
        correctDate: true,
        [event.target.name]: event.target.value
      });
    }
  };
  /**
   * Check if order is already exists in the table
   * @param {array} newOrder value with new battle invoice No
   * @returns true or false
   */
  checkExistingOrder = (newOrder) => {
    const { products } = this.props;
    const isFound = products.some((el) => {
      if (el.cNo === newOrder.cNo) {
        return true;
      }
      return false;
    });
    return isFound;
  };
  /**
   * Submit data to db
   * @param {*} e 
   * @param {*} values 
   */
  handleValidRequestSubmit = (e, values) => {
    const { onAddProductToOrder, onUpdateProductToOrder, managers } = this.props;
    const { requestedDate, isEdit, checkCno, productToOrder } = this.state;
    let orderArr = [];
    if(isEdit){
      values.product.split(/\r?\n/).map((val, key) => { return val !== '' && orderArr.push(productToOrder.ids[key] +' qty'+ val); });
      let updateOrder = [];
      orderArr.map((id, index) => {
        updateOrder.push({
          _id: id.split('qty')[0].replace(/[\n\t\r]/g, '').trim(),
          manager: values['manager'],
          fname: '',
          sname: '',
          product: id.split('qty')[1].replace(/[\n\t\r]/g, '').trim(),
          qty: id.split('qty')[2].replace(/[\n\t\r]/g, '').trim(),
          cNo: id.split('qty')[3].replace(/[\n\t\r]/g, '').trim(),
          category: id.split('qty')[4].replace(/[\n\t\r]/g, '').trim(),
        })
        managers.map((manager) => {
          if(values['manager'] === manager._id){
            updateOrder[0]['fname'] = manager.fname;
            updateOrder[0]['sname'] = manager.sname;
          }
        })
        onUpdateProductToOrder(updateOrder[0])
        updateOrder = [];
      })
      this.toggleNewOrderModal();
    } else {
      let newOrder = [];
      values.product.split(/\r?\n/).map((val, key) => { return val !== '' && orderArr.push(val); });
      orderArr.map((id, index) => {
        newOrder.push({
          date: requestedDate.split('/').reverse().join('-'),
          manager: values['manager'],
          fname: '',
          sname: '',
          product: id.split('qty')[0].replace(/[\n\t\r]/g, '').trim(),
          qty: id.split('qty')[1].replace(/[\n\t\r]/g, '').trim(),
          cNo: id.split('qty')[2].replace(/[\n\t\r]/g, '').trim(),
          category: id.split('qty')[3].replace(/[\n\t\r]/g, '').trim(),
          // comments: values['comments'],
          setAsOrdered: false,
          setAsArrived: false,
          module: 'Bot Purchase Notification',
          option: 'addProductsPurchase'
          // page: 'addProducts' + index
        })
        managers.map((manager) => {
          if(values['manager'] === manager._id){
            newOrder[0]['fname'] = manager.fname;
            newOrder[0]['sname'] = manager.sname;
          }
        })
        if (this.checkExistingOrder(newOrder[0])) {
          this.setState({ checkCno: true });
        } else {
          this.setState({ checkCno: false });
          onAddProductToOrder(newOrder[0]);
          newOrder = [];
        }
      });
      !checkCno && this.toggleNewOrderModal(); 
    }
  };
  /**
   * Hide alert
   * @returns updated state
   */
  hideAlert = () => this.setState({ alert: null });
  /**
   * Function to set products as ordered
   * @param {array} requestedProduct
   */
  // handleOrderedStatus = (requestedProduct) => {
  //   console.log(requestedProduct)
  //   const { onUpdateProductToOrder } = this.props;
  //   requestedProduct.ids.map((id, index) => {
  //     let updateOrder = [];

  //     updateOrder.push({
  //       _id: id,
  //       cNo: requestedProduct.cNo,
  //       setAsOrdered: !id.setAsOrdered
  //     })
  //     onUpdateProductToOrder(updateOrder[0])
  //     updateOrder = [];
  //   })


  // };
handleOrderedStatus = (requestedProduct) => {
  const { onUpdateProductToOrder } = this.props;
console.log(requestedProduct)
  const prodString = requestedProduct.products
    .map(
      (product, index) =>
        `Product: ${product} qty: ${requestedProduct.qtys[index] ?? 0} \n`
    )
    .join("");

  requestedProduct.ids.forEach((id, index) => {
    onUpdateProductToOrder({
      _id: id,
      cNo: requestedProduct.cNo,
      setAsOrdered: !requestedProduct.setAsOrdered[index],
      prodString,
      notifications: [requestedProduct.manager]
    });
  });
};
  /**
   * Function to delete request from the table
   * @param {array} requestedProduct
   */
  handleDeleteRequest = (requestedProduct) => {
    const getAlert = () => (
      <SweetAlert
        danger
        showCancel
        confirmBtnText='Yes, delete it!'
        confirmBtnBsStyle='danger'
        title='Are you sure?'
        onConfirm={() => this.deleteRequestAlert(requestedProduct)}
        onCancel={this.hideAlert}
        focusCancelBtn
      ></SweetAlert>
    );

    this.setState({
      alert: getAlert()
    });
  };
  /**
   * Delete row from the table
   * @param {*} requestedProduct 
   */
  deleteRequestAlert = (requestedProduct) => {
    const { onDeleteProductToOrder } = this.props;
    onDeleteProductToOrder(requestedProduct.cNo);
    this.hideAlert();
  };
  render() {
    const { SearchBar } = Search;
    const { products, managers, profileData, loading } = this.props;
    const { ProductsListColumns, modalNewProductToOrder, selectedRows, isEdit, viewArrived, checkCno, productsArr, requestedDate, correctDate, productToOrder, alert, my_requested_orders } = this.state;
    const pageOptions = {
      sizePerPage: my_requested_orders.length !== 0 && my_requested_orders[0]['manager'] === 'No Results Found' ? 0 : 100,
      sizePerPageList: [100, 300, 500],
      totalSize: my_requested_orders.length !== 0 && my_requested_orders[0]['manager'] === 'No Results Found' ? 0 : this.groupedData(products).length,
      custom: true
    };
    console.log(this.props)
    // const pageOptions = {
    //   sizePerPage: my_requested_orders.length !== 0 && my_requested_orders[0]['manager'] === 'No Results Found' ? 0 : this.groupedData(products).length,
    //   sizePerPageList: [100, 300, 500],
    //   totalSize: my_requested_orders.length !== 0 && my_requested_orders[0]['manager'] === 'No Results Found' ? 0 : this.groupedData(products).length,
    //   custom: true
    // };
    const defaultSorted = [
      {
        dataField: 'updatedAt', // if dataField is not match to any column you defined, it will be ignored.
        order: 'desc' // desc or asc
      }
    ];
    const selectRow = {
      mode: 'checkbox',
      selected: this.state.selectedRows,
      onSelectAll: (isSelect, rows, e) => {
        let selectedWeights = 0;
        let selectedAgentFees = 0;
        let selectedNoOfToxin = 0;
        let selectedRows = [];
        let selectedAllArr = [];
        if (!isSelect) {
          this.setState({
            selectedRows: [],
            selectedWeights: 0,
            selectedAgentFees: 0,
            selectedNoOfToxin: 0
          });
        } else {
          if (this.state.displayHiddenPaid === false && this.state.displayHiddenCompleted === false) {
            selectedAllArr = rows.filter((r) => r.completed === false);
          } else if (this.state.displayHiddenPaid === true) {
            selectedAllArr = rows.filter((r) => r.agentPaid === false);
          } else {
            selectedAllArr = rows;
          }
          selectedAllArr.map((row, i) => {
            selectedRows.push(row._id);
            selectedWeights += row.weight;
            selectedAgentFees += row.agentPaymentAmount;
            selectedNoOfToxin += row.toxins === true ? 1 : 0;
            // this.setState({
            //   selectedRows,
            //   selectedWeights,
            //   selectedAgentFees,
            //   selectedNoOfToxin
            // });
          });
        }
      },
      onSelect: (row, isSelect, rowIndex, e) => {
        // let selectedRows = [];
        if (!isSelect) {
          // this.state.selectedRows = this.state.selectedRows.filter(function (el) {
          //   return el != row._id;
          // });

          // this.state.selectedWeights -= row.weight;
          // this.state.selectedAgentFees -= row.agentPaymentAmount;
          // this.state.selectedNoOfToxin -= row.toxins == true ? 1 : 0;
          // this.setState({
          //   selectedRows: this.state.selectedRows,
          //   selectedWeights: this.state.selectedWeights,
          //   selectedAgentFees: this.state.selectedAgentFees,
          //   selectedNoOfToxin: this.state.selectedNoOfToxin
          // });
        } else {
          // this.state.selectedRows.push(row._id);
          // this.state.selectedWeights += row.weight;
          // this.state.selectedAgentFees += row.agentPaymentAmount;
          // this.state.selectedNoOfToxin += row.toxins == true ? 1 : 0;
          // this.setState({
          //   selectedRows: this.state.selectedRows,
          //   selectedWeights: this.state.selectedWeights,
          //   selectedAgentFees: this.state.selectedAgentFees,
          //   selectedNoOfToxin: this.state.selectedNoOfToxin
          // });
        }
      }
    };
    return (
      <React.Fragment>
        <PageLoader progress={!loading && {"step": "Completed","time": 100}} isLoading={loading}/>
        <div className='page-content'>
          <MetaTags>
            <title>Requested Products</title>
          </MetaTags>
          <Container fluid>
          {profileData.permissions.includes('purchaseRqstdPrdAccess') ? (
              <>
              {/* Render Breadcrumbs */}
              <Breadcrumbs title='Korupharma' breadcrumbItem='Requested Products' />
              <Row id='card-section' onLoad={this.getScreenHeight()}>
                <Col lg='12'>
                  <Card> 
                    <CardBody className='cardBodySticky'>
                      <PaginationProvider
                        pagination={paginationFactory(pageOptions)}
                        keyField='_id'
                        columns={ProductsListColumns}
                        data={ my_requested_orders.length !== 0 && my_requested_orders[0]['manager'] === 'No Results Found' ? [] : 
                                my_requested_orders.length !== 0 ? my_requested_orders : this.groupedData(products) }
                      >
                      {({ paginationProps, paginationTableProps }) => (
                        <ToolkitProvider
                          keyField='_id'
                          columns={ProductsListColumns}
                          data={ my_requested_orders.length !== 0 && my_requested_orders[0]['manager'] === 'No Results Found' ? [] : 
                                  my_requested_orders.length !== 0 ? my_requested_orders : this.groupedData(products) }
                          search
                        >
                        {(toolkitprops) => (
                          <React.Fragment>
                            <Row className='mb-2'>
                              <Col md='4' sm='12' className='d-flex'>
                                <div className='search-box ms-2 mb-2 me-5 d-inline-block '>
                                  <div className='position-relative'>
                                    <SearchBar {...toolkitprops.searchProps} />
                                    <i className='bx bx-search-alt search-icon' />
                                  </div>
                                </div>
                                <FormGroup className='d-flex ps-0 justify-content-between form-switch form-switch-lg form-group me-2'>
                                  <Label for='myOrders'> My Orders </Label>
                                  <Input
                                    name='myOrders'
                                    onChange={(e) => this.filterMyOrders(e)}
                                    className='ms-4'
                                    id='myOrders'
                                    type='checkbox'
                                    value={false}
                                  />
                                  <Notification compData={my_requested_orders.length !== 0 && my_requested_orders[0]['manager'] === 'No Results Found' ? [] : 
                                  my_requested_orders.length !== 0 ? my_requested_orders : this.groupedData(products)} keyWord='purchase' module='Bot Purchase Notification' />
                                </FormGroup>
                              </Col>
                              <Col md='8' className='text-sm-end'>
                                <Button
                                  color='primary'
                                  className='btn-block mb-2 me-2 btn btn-primary'
                                  onClick={this.handleNewOrderClick}
                                  id='create-order-btn'
                                >
                                  <i className='mdi mdi-plus-circle-outline me-1' />
                                  Add Products to Order
                                </Button>
                                <Modal
                                  size='lg'
                                  isOpen={modalNewProductToOrder}
                                  className={this.props.className}
                                  toggle={this.toggleNewOrderModal}
                                >
                                  <ModalHeader toggle={this.toggleNewOrderModal} tag='h4'>
                                    {!!isEdit ? 'Edit Order' : 'Add Order'}
                                  </ModalHeader>
                                  <ModalBody>
                                    {checkCno && ( <Alert color='danger'> Order with this 1c Number is already exist.{' '}</Alert> )}
                                    <AvForm onValidSubmit={this.handleValidRequestSubmit}>
                                      <Row>
                                        <Col md={12}>
                                          <FormGroup className='mb-3'>
                                            <AvField
                                              name='product'
                                              label='Product'
                                              type='textarea'
                                              className='font-size-20'
                                              rows={10}
                                              id='productField'
                                              value={
                                                productsArr &&
                                                productsArr
                                                  .map((v, i) => {
                                                    return `${v.prodName.replace(/\n/g, '')} qty${v.prodQty} qty${v.cNo.replace(/\n/g, '')} qty${v.category.replace(/\n/g, '')}\n`;
                                                  })
                                                  .join('')
                                              }
                                              onKeyPress={(e) => {
                                                e.preventDefault();
                                              }}
                                              onPaste={(e) => {
                                                e.preventDefault();
                                                const text = e.clipboardData.getData('text/plain');
                                                document.execCommand('insertText', false, text);
                                              }}
                                            />
                                          </FormGroup>
                                        </Col>
                                      </Row>
                                      <Row>
                                        <Col md={6}>
                                          <FormGroup className='mb-3'>
                                            <Label>Date</Label>
                                            <InputMask
                                              mask='99/99/9999'
                                              value={requestedDate}
                                              name='requestedDate'
                                              disabled
                                              onChange={this.onChange}
                                              className={ correctDate ? ' form-control input-mask' : 'form-control input-mask is-invalid' }
                                            />
                                            {!correctDate && (<div className='invalid-feedback'>Invalid Date. Please use dd/mm/yyyy format</div>)}
                                          </FormGroup>
                                        </Col>
                                        <Col md={6}>
                                          <FormGroup className='mb-3'>
                                            <AvField
                                              type='select'
                                              name='manager'
                                              className='form-select'
                                              label='Manager'
                                              errorMessage='Please select manager'
                                              validate={{
                                                required: {
                                                  value: true
                                                }
                                              }}
                                              value={ productToOrder.manager ? productToOrder.manager._id : profileData._id }
                                            >
                                              <option>Choose</option>
                                              {managers.map((manager) => {
                                                return (
                                                  <option key={manager._id} value={manager._id}>
                                                    {manager.fname} {manager.sname}
                                                  </option>
                                                );
                                              })}
                                            </AvField>
                                          </FormGroup>
                                        </Col>
                                      </Row>
                                      {/* <Row>
                                        <Col md={12}>
                                          <FormGroup className='mb-3'>
                                            <AvField
                                              name='comments'
                                              label='Comments'
                                              type='textarea'
                                              className='font-size-20'
                                              rows={3}
                                              value={ productToOrder.comments ? productToOrder.comments : '' }
                                            />
                                          </FormGroup>
                                        </Col>
                                      </Row> */}
                                      <Row>
                                        <Col>
                                          <div className='text-end'>
                                            {loading && <BtnLoader />}
                                            <button
                                              className='btn btn-success save-user'
                                              disabled={ !correctDate || (loading && true) }
                                            >
                                              {!!isEdit ? 'Edit Request' : 'Add Request'}
                                            </button>
                                          </div>
                                        </Col>
                                      </Row>
                                    </AvForm>
                                  </ModalBody>
                                </Modal>
                                <Button
                                  color='primary'
                                  className='font-16 btn-block btn btn-warning mb-2 me-2 btn-lg'
                                  onClick={this.handleHideCompletedOrders}
                                  id='create-order-btn'
                                >
                                  <i className='mdi mdi-reload me-1' />
                                  Hide Completed Orders
                                </Button>
                                <Button
                                  color='primary'
                                  className='font-16 btn-block btn btn-dark mb-2 me-2 btn-lg'
                                  onClick={this.handleViewCompletedOrders}
                                  id='create-order-btn'
                                >
                                  <i
                                    className={viewArrived ? 'mdi mdi-eye-off me-1' : 'mdi mdi-eye me-1'}
                                  />
                                  {viewArrived ? 'Reset' : 'View Completed Orders'}
                                </Button>
                              </Col>
                            </Row>
                            <Row id='table-section'>
                              <BootstrapTable
                                {...toolkitprops.baseProps}
                                {...paginationTableProps}
                                selectRow={selectRow}
                                defaultSorted={defaultSorted}
                                rowClasses={this.rowClasses}
                                classes={'table align-middle table-nowrap'}
                                headerClasses='header-class is-sticky-hdr'
                                id='tableScroll'
                                filter={filterFactory()}
                                noDataIndication={this.indication}
                                responsive
                              />
                              <Col className='inner-custom-pagination d-flex mt-1'>
                                <div className='d-inline custom-dropdown'>
                                  <SizePerPageDropdownStandalone {...paginationProps} />
                                </div>
                                <div className='text-md-right ms-auto pagination pagination-rounded justify-content-end mb-2'>
                                  <PaginationListStandalone {...paginationProps} />
                                </div>
                              </Col>
                            </Row>
                            {alert}
                          </React.Fragment>
                        )}
                        </ToolkitProvider>
                      )}
                      </PaginationProvider>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
              </>
          ) : (
            <Alert color='danger'> You do not have access to this page. </Alert>
          )}
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

ProductOrderList.propTypes = {
  products: PropTypes.array,
  onGetProductsToOrder: PropTypes.func,
  onAddProductToOrder: PropTypes.func,
  onUpdateProductToOrder: PropTypes.func,
  onDeleteProductToOrder: PropTypes.func,
};

const mapStateToProps = ({ purchases }) => ({
  products: purchases.products,
  managers: purchases.managers,
  loading: purchases.loading
});

const mapDispatchToProps = (dispatch) => ({
  onGetProductsToOrder: () => dispatch(getProducts()),
  onAddProductToOrder: (productOrder) => dispatch(addProduct(productOrder)),
  onUpdateProductToOrder: (productOrder) => dispatch(updateProduct(productOrder)),
  onDeleteProductToOrder: (productOrder) => dispatch(deleteProduct(productOrder)),
  onGetArrivedProducts: (id) => dispatch(getArrivedProducts(id))
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(ProductOrderList));
